import React, { ComponentType } from 'react';
import { ComponentErrorBoundary } from './component-error-boundary';

interface IssuesComponentProps {
  apiUrl: string;
  enableSorting?: boolean;
  showActions?: boolean;
}

interface IssuesGridWrapperProps {
  IssuesComponent: ComponentType<IssuesComponentProps>;
  apiUrl: string;
}

export function IssuesGridWrapper({
  IssuesComponent,
  apiUrl,
}: IssuesGridWrapperProps): React.JSX.Element {
  return (
    <ComponentErrorBoundary>
      <IssuesComponent apiUrl={apiUrl} enableSorting showActions />
    </ComponentErrorBoundary>
  );
}
